import { useEffect, useState } from 'react';
import { DefaultOptionType } from 'antd/lib/select';
import { useFetch } from './useFetch';

export const useNotificationDestinationTypes = () => {
    const fetch = useFetch();
    const [data, setData] = useState<DefaultOptionType[]>([]);

    const getList = async () => {
        const response = await fetch.request({
            url: '/notifications/destination-types',
        });
        if (response.success) {
            setData(response.data);
        }
    };

    useEffect(() => {
        getList();
    }, []);

    return {
        data,
        loading: fetch.loading,
    };
};
